import { IMappers } from '../../../repositories/monolith-python/v2/validate-visible-violations';
import { IValidateVisibleViolationsFail, IValidateVisibleViolationsSuccess } from '../types';
import { getSkipHashHeader } from './getSkipHashHeader';

export const mappers: IMappers<IValidateVisibleViolationsSuccess, IValidateVisibleViolationsFail> = {
  204: () => ({
    isValid: true,
  }),
  400: ({ errors }, headers) => ({
    isValid: false,
    payload: {
      errors: errors || [],
      skipHash: getSkipHashHeader(headers),
    },
  }),
};
